import { render } from "./DecorationLibraryLegacyRedirect.vue?vue&type=template&id=7ce6ceff&scoped=true"
import script from "./DecorationLibraryLegacyRedirect.vue?vue&type=script&lang=js"
export * from "./DecorationLibraryLegacyRedirect.vue?vue&type=script&lang=js"

import "./DecorationLibraryLegacyRedirect.vue?vue&type=style&index=0&id=7ce6ceff&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce6ceff"]])

export default __exports__